function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

type BICERegistry = {
  businessDestinationName: string;
  businessDestinationIdentifier: string;
  businessDestinationNumber: string;
  amount: number;
  bankCode: number;
  firstNumber: string;
  secondNumber: string;
  thirdNumber: string;
  forthNumber: string;
  operationNumber: string;
  destinationHolderEmail: string;
};

const MAXIMUM_AMOUNT_PER_FILE = 50 * 1000000;

export const handleExportBICECsv = async (
  payments: any,
  id: any,
  message?: string,
) => {
  const filename = `Bice_${id}_${new Date().toDateString()}`;

  const registries = getRegistries(payments);

  let parsedData = '';
  let fileCount = 0;
  let currentFileAmount = 0;
  for (const registry of registries) {
    if (currentFileAmount + registry.amount > MAXIMUM_AMOUNT_PER_FILE) {
      const csvContent = `data:text/csv;charset=utf-8,${parsedData}`;
      const encodedURI = encodeURI(csvContent);

      const a = document.createElement('a');
      a.href = encodedURI;
      a.download = `${filename}-${fileCount}.csv`;
      a.click();

      fileCount += 1;
      parsedData = '';
      currentFileAmount = 0;
      // eslint-disable-next-line no-await-in-loop
      await sleep(100);
    }

    const row = Object.values(registry).join(';') + '\n';
    parsedData += row;
    currentFileAmount += registry.amount;
  }

  const csvContent = `data:text/csv;charset=utf-8,${parsedData}`;
  const encodedURI = encodeURI(csvContent);

  const a = document.createElement('a');
  a.href = encodedURI;
  a.download = `${filename}-${fileCount}.csv`;
  a.click();
};

function getRegistries(payments: any): BICERegistry[] {
  const type = payments[0].source;
  switch (type) {
    case 'payment-request-passive':
      return payments.map((x: any) => ({
        businessDestinationName: x.bankAccountDestinationHolderName.slice(
          0,
          40,
        ),
        businessDestinationIdentifier:
          x.bankAccountDestinationHolderIdentifier.replace('-', ''),
        businessDestinationNumber: x.bankAccountDestinationNumber,
        amount: x.amount,
        bankCode: x.bankAccountDestinationBankCode,
        firstNumber: '1',
        secondNumber: '0',
        thirdNumber: '1',
        forthNumber: '1',
        operationNumber: x.sourceId,
        destinationHolderEmail: x.bankAccountDestinationHolderEmail,
      }));

    default:
      return payments.map((x: any) => ({
        businessDestinationName: x.businessDestinationName.slice(0, 40),
        businessDestinationIdentifier: x.businessDestinationIdentifier.replace(
          '-',
          '',
        ),
        businessDestinationNumber: x.bankAccountDestinationNumber,
        amount: x.amount,
        bankCode: x.bankAccountDestinationBankCode,
        firstNumber: '1',
        secondNumber: '0',
        thirdNumber: '1',
        forthNumber: '1',
        operationNumber: x.sourceId,
        destinationHolderEmail: x.bankAccountDestinationHolderEmail,
      }));
  }
}
